// import Example, { Example2 } from '../Example';
import { BaseProps } from '../utils/types';
import { ReactElement } from 'react';
import { OktaSignIn, AdvantaMVPCharts } from '../pages';
import { RoleBaseNavigation } from './roleBaseNavigation';
import { AUTH_PATH_CONSTANTS } from '../utils/constants/route';
import { MVPReports } from '../pages/advanta-mvp-charts/reports';
import { MVPArchieved } from '../pages/advanta-mvp-charts/archieved';
import createReport from '../pages/advanta-mvp-charts/reports/createReport';
import { ReportDetailsMobile } from '../pages/advanta-mvp-charts/reports/reportDetailsMobile';

export type routeProps = {
  path: string;
  protected: boolean;
  element: React.FC<BaseProps>;
  roles: string[];
};

export const routes: routeProps[] = [
  {
    path: AUTH_PATH_CONSTANTS.BASE_URL,
    protected: false,
    element: RoleBaseNavigation,
    roles: [],
  },
  {
    path: AUTH_PATH_CONSTANTS.MVP_CHARTS,
    protected: true,
    element: AdvantaMVPCharts,
    roles: [],
  },
  {
    path: AUTH_PATH_CONSTANTS.REPORTS,
    protected: true,
    element: MVPReports,
    roles: [],
  },
  {
    path: AUTH_PATH_CONSTANTS.ARCHIEVED,
    protected: true,
    element: MVPArchieved,
    roles: [],
  },
  {
    path: AUTH_PATH_CONSTANTS.FIELD_REPORT,
    protected: true,
    element: createReport,
    roles: [],
  },
  {
    path: AUTH_PATH_CONSTANTS.REPORT_DETAILS_MOBILE,
    protected: true,
    element: ReportDetailsMobile,
    roles: [],
  },
];

export const nonAuthRoutes: {
  path: string;
  element: ReactElement;
}[] = [
  {
    path: '/',
    element: <OktaSignIn />,
  },
  {
    path: 'sign-in',
    element: <OktaSignIn />,
  },
  // {
  //   path: 'components-example',
  //   element: <Example />,
  // },
  // {
  //   path: 'sign-in',
  //   element: <OtpSignInPage />,
  // },
  // {
  //   path: 'sign-up',
  //   element: <Example2 />,
  // },
  // {
  //   path: 'callback',
  //   element: <LoginCallBack />,
  // },
];
